import { Form, Button } from "react-bootstrap";
import { authServices } from "../APIServices/UserData/authServices";
import { useNavigate } from "react-router-dom";

const StartRegistration = ({
  setNextStep,
  setName,
  name,
  setEmail,
  email,
  roleType,
  setRoleType,
  setLoader,
  loader,
  token
}) => {
  const navigate = useNavigate();
  const checkRegistrationSetup = async () => {
    setLoader(true)
    let userData = {}
    userData.name = name
    userData.email = email
    userData.roleType = roleType
    let data = await authServices.checkRegistrationSetup(userData)
    if (data?.statusCode === 200) {
      setNextStep(data?.status)
      setName(data?.name)
      setEmail(data?.email)
      setRoleType(data?.roleType)
    }
    setLoader(false)
  }

  const goToLogin = () => {
    navigate("/login");
  };

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>{token ? "Name" : "Organization Name"}</Form.Label>
        <Form.Control
          onChange={(e) => setName(e.target.value)}
          value={name}
          className="form-input"
          placeholder={`Enter ${token ? "Name" : "Organization Name"}`}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Email</Form.Label>
        <Form.Control
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          type="email"
          disabled={token}
          className="form-input"
          placeholder="Enter your email"
        />
      </Form.Group>

      <div className="hstack gap-2">
        <Button
          onClick={checkRegistrationSetup}
          className="w-100 btn-primary"
          disabled={loader}
        >
          Continue
        </Button>
      </div>
      <p className="text-center text-muted-sm mt-3">
        Already have an account?{" "}
        <a onClick={goToLogin}>
          <span className="link-primary">Sign in</span>
        </a>
      </p>
    </>
  );
};

export default StartRegistration;
